export const warningMessage = `At least one video has already been assigned.
If you attempt to assign a video to a class that has already been assigned
the video, it will not be reassigned.`;
